import type { GameMeta } from "../../common/gameMeta.js";
import type { CircleRiderVariantConfig } from "./variantConfig.js";

export const meta = {
	name: "Circle Rider",
	minPlayers: 1,
	maxPlayers: 4,
	description: "Ride the circles round and round",
	instructions: "Hit the teal circle — first to 3 wins!",
	mobileBrowserCompatible: true,
	modifiers: [
		{
			id: "dangerZone",
			label: "Danger Zone",
			instructions: "Click the teal circle to score — but hitting the red one costs you a point!",
			config: { penalizeDecoy: true } satisfies CircleRiderVariantConfig,
		},
	],
} satisfies GameMeta;
